import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import { ddStyles } from "../../utils/CommonStyles.js";

let info = "";
function EditSupplyChain() {
    const navigate = useNavigate();

    const [errorValue, setErrorValue] = useState("");
    const [delegates, setDelegates] = useState([]);
    const [buyerLoaded, setBuyerLoaded] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierLoaded, setSupplierLoaded] = useState(false);
    const [supplierSelected, setSupplierSelected] = useState({ name: "supplierId", label: "", value: 0 });
    const [buyers, setBuyers] = useState([]);
    const [buyerOptions, setBuyerOptions] = useState([]);
    const [searchBuyerLoaded, setSearchBuyerLoaded] = useState(false);
    const [buyerSelected, setBuyerSelected] = useState({ name: "buyerId", label: "", value: 0 });
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);
	const today = new Date().toISOString().split("T")[0];
    const [editFormData, setEditFormData] = useState([]);
    const [searchFormData, setSearchFormData] = useState({partnerKey: 0, companyKey: 0});
    let errorString = [];

    useEffect(() => {
        fetchBuyers();
    }, []);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };
	function fetchBuyers() {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("FetchBuyers", "/Service/CompanyService/FetchBuyers", requestOptions, fetchBuyersSuccess, fetchBuyersFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchBuyersFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.buyerListNotRetrieved"));
    }
    function fetchBuyersSuccess(responseData) {
        let fetchBuyersResponse;
        if (responseData) {
            fetchBuyersResponse = responseData.fetchBuyersResponse;
            if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "0") {
                setBuyerValues(fetchBuyersResponse.companies);
                setBuyers(fetchBuyersResponse.companies);
            } else if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchBuyersResponse) {
                setErrorValue(t("error.error") + " " + fetchBuyersResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }

    function setSupplierValues(companyObj) {
        let companyValue = {};
        let companyOptionList = [];
        companyOptionList.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                companyValue.value = company.companyId;
                companyOptionList.push(companyValue);
                companyValue = {};
            });
        }
        setSupplierOptions(companyOptionList);
        setSupplierLoaded(true);
    }

    const supplierHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";
        if (companyId === searchFormData.partnerKey) {
            return;
        }
        setDelegates([]);
        setSupplierSelected({ ...supplierSelected, label: companyName, value: companyId });
        setSearchFormData({ ...searchFormData, partnerKey: companyId });
    }

    function fetchCompanies(clientId) {
        setErrorValue("");
        if ((!clientId || clientId === 0)) {
            return;
        }
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                excludeCompany: clientId
            }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, retrieveCompaniesSuccess, retrieveCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function retrieveCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setSupplierValues(fetchCompaniesResponse.companies.slice());
                if (fetchCompaniesResponse.companies) {
                    setSuppliers(fetchCompaniesResponse.companies.slice());
                }
            } else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchCompaniesResponse) {
                setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }

    function retrieveCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.companyListNotRetrieved"));
    }

    function setBuyerValues(buyers) {
        let buyerValue = {};
        let buyerOptionList = [];
        buyerOptionList.push({ label: "", value: 0 });
        if (buyers && buyers.length > 0) {
            buyers.map((buyer, index) => {
                buyerValue.label = buyer.companyName + ', ' + (buyer.city ? buyer.city + ', ' : '') + buyer.stateCode + ', ' + buyer.countryCode;
                buyerValue.value = buyer.companyId;
                buyerOptionList.push(buyerValue);
                buyerValue = {};
            });
        }
        setBuyerOptions(buyerOptionList);
        setSearchBuyerLoaded(true);
    }

    const searchBuyerHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";
        if (companyId === searchFormData.companyKey) {
            return;
        }
        setDelegates([]);
        searchFormData.partnerKey = 0;
        setSupplierSelected({ ...supplierSelected, label: "", value: 0 });
        setSuppliers([]);
        setSupplierOptions([]);
        setBuyerSelected({ ...buyerSelected, label: companyName, value: companyId });
        setSearchFormData({ ...searchFormData, companyKey: companyId });
        if (companyId && companyId > 0) {
            fetchCompanies(companyId);// fetch all suppliers
        }
    }
    function fetchSupplyChainFieldValues() {
        setErrorValue("");
        let companyId = searchFormData.companyKey;
        if ((!companyId || companyId === 0)) {
            setErrorValue(t("error.buyer.Reqd"));
            return;
        }
        let supplierCompanyId = searchFormData.partnerKey;
         if ((supplierCompanyId && supplierCompanyId > 0 && supplierCompanyId === companyId)) {
            setErrorValue(t("error.invalid.delegate.relation"));
            return;
        }
        setIsLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web",
                supplierKey: supplierCompanyId,
                buyerCompanyId: companyId,
                getAll: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetSupplyChainFieldValues", "/Service/CompanyService/GetSupplyChainFieldValues", requestOptions, fetchSupplyChainSuccess, fetchSupplyChainFail);
        } catch (error) {
            setIsLoading(false);
            setBuyerLoaded(false);
            throw new Error(error.message);
        }
    }

    function fetchSupplyChainFail(redirect) {
        setIsLoading(false);
        setBuyerLoaded(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.partnerDelegateNotRetrieved"));
    }
	function setDelegateValues(fields) {
        let delegateValue = {delegate: {}, buyers :[]};
        let delegateValues = [];
        let buyerOptionList = [];
        let buyerValue = { label: "", value: 0 };
        if (fields && fields.length > 0) {
            fields.map((field, index) => {
				buyerOptionList = [];
				buyerValue = {};
				delegateValue.delegate = field.delegate;
				if (field.buyers && field.buyers.length > 0) {
            		field.buyers.map((buyer, index1) => {
		                buyerValue.label = buyer.companyName + ', ' + (buyer.city ? buyer.city + ', ' : '') + buyer.stateCode + ', ' + buyer.countryCode;
		                buyerValue.value = buyer.partnershipKey + "-" + buyer.companyId;
		                buyerOptionList.push(buyerValue);
		                buyerValue = {};
	            	});
	            }
	            delegateValue.buyers = buyerOptionList;
	            delegateValues.push(delegateValue);
            	delegateValue = {delegate: {}, buyers :[]};
            });
        }
        setBuyerLoaded(true);
        setDelegates(delegateValues);
        //console.log(editFormData + " " + JSON.stringify(editFormData));
    }
    function fetchSupplyChainSuccess(responseData) {
        let getSupplyChainFieldResponse;
        if (responseData) {
            getSupplyChainFieldResponse = responseData.getSupplyChainFieldResponse;
            if (getSupplyChainFieldResponse && getSupplyChainFieldResponse.errorCode === "0") {
                if (getSupplyChainFieldResponse.fields) {
                    setDelegateValues(getSupplyChainFieldResponse.fields);
                } else {
                    setDelegates([]);
                    setBuyerOptions([]);
                }
            } else if (getSupplyChainFieldResponse && getSupplyChainFieldResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getSupplyChainFieldResponse) {
                setErrorValue(t("error.error") + " " + getSupplyChainFieldResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }
    const valueHandler = (keyValue, e) => {
		const { name, value } = e.target;
		let fieldValue = value;
		if(name == "endDate"){
			if (typeof value === 'undefined') {
				fieldValue = "";
			}
		} else if(name == "startDate"){
			if (typeof value === 'undefined' || value == "") {
				fieldValue = today;
			}
		}
		
		let found = false;
		editFormData.map(item => {
			if(item.partnershipKey == keyValue){
				found = true;
				return found;
			}
		});
		if(found){
			setEditFormData(editFormData => 
			    editFormData.map(item => 
			      item.partnershipKey == keyValue ? { ...item, [name]: fieldValue } : item )
			);
		} else {
			alert(t("error.rowNotSelected"));
		}
	}
	const buyerHandler = (selectedOptions, keyValue) => {
		let found = false;
		editFormData.map(item => {
			if(item.partnershipKey == keyValue){
				found = true;
				return found;
			}
		});
		if(found){
			setEditFormData(editFormData => 
			    editFormData.map(item => 
			      item.partnershipKey == keyValue ? { ...item, buyers : selectedOptions} : item )
			);
		} else {
			alert(t("error.rowNotSelected"))
		}
	}
	const handleChange = (e) => {
	    const { value, checked } = e.target;
	    const valueArr = value.split("-");
	    const formData = {partnershipKey: valueArr[0], supplierKey: valueArr[1]};
	    let itemStartDate = today;
	    delegates.map((item) => {
		   if(item.delegate.partnershipKey == valueArr[0]){
			   itemStartDate = item.delegate.startDate;
		   }
	    });
		let itemEndDate = "";
		delegates.map((item) => {
		   if(item.delegate.partnershipKey == valueArr[0]){
			   itemEndDate = item.delegate.endDate;
		   }
	    });
	    formData.startDate = itemStartDate;
	    formData.endDate = itemEndDate;
	    formData.buyers = [];
	    formData.buyerObjects = [];
	    
	    if (checked) {
	      setEditFormData(editFormData => [ ...editFormData, formData ]);
	    } else {
	      setEditFormData(editFormData => editFormData.filter(item => item.partnershipKey != formData.partnershipKey));
	    } 
	};
	const submitRecords = () => {
	   let buyerObjects= [];
       editFormData.map((formData, index) => {
		   buyerObjects = rebuildBuyerObjects(formData.buyers);
		   formData.buyerObjects = buyerObjects;
	   });
	   if(validate()){
			let serverParams = {
				buyerPartnerships: editFormData
			};
			const requestOptions = {
				credentials: "same-origin",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(serverParams),
			};
			//console.log(JSON.stringify(serverParams));
			try {
				FetchUtil.fetchAPI("AddBuyersToSupplyChain", "/Service/PartnerSubsService/AddBuyersToSupplyChain", requestOptions, addBuyersToSupplyChainSuccess, addBuyersToSupplyChainFail);
			} catch (error) {
				setErrorValue(error.message);
			}
		} 
	   
	};

	function addBuyersToSupplyChainFail() {
		info = "";
		setErrorValue(t("error.supplyChainEditFailed"));
	}
	function addBuyersToSupplyChainSuccess(responseData) {
		let addBuyersToSupplyChainResponse;
		if (responseData) {
			addBuyersToSupplyChainResponse = responseData.addBuyersToSupplyChainResponse;
			if (addBuyersToSupplyChainResponse) {
				if (addBuyersToSupplyChainResponse.errorCode === "0") {
					resetValues();
					info = t("info.success.stored");
					fetchSupplyChainFieldValues();
				} else if (addBuyersToSupplyChainResponse.errorCode === "114") {
					info = "";
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					info = "";
					setErrorValue(t("error.error") + " " +
						addBuyersToSupplyChainResponse.errorMessage
					);
				}
			}
		}
	}
	
	function setEndDateValue(delegateItem){
		let formData = editFormData.find(item => item.partnershipKey == delegateItem.delegate.partnershipKey)
		if(formData){
			return formData.endDate;
		} else {
			return delegateItem.delegate.endDate;
		}
	}

    const validate = () => {
		let noError = true;
		errorString = [];
		let startDate;
		let endDate;
		editFormData.map((formData, index) => {
			let delegateItem = delegates.find(eachDelegate => formData.partnershipKey == eachDelegate.delegate.partnershipKey);
			if (!formData.startDate) {
				errorString.push(t("error.startdateReqd")+" "+delegateItem.delegate.buyerName + "<--" + delegateItem.delegate.supplierName);
				noError = false;
			}
			if(formData.startDate instanceof Object){
				startDate = formData.startDate.getTime();
			} else {
				startDate = new Date(formData.startDate).getTime();
			}
			if(formData.endDate){
				if(formData.endDate instanceof Object){
					endDate = formData.endDate.getTime();
				} else {
					endDate = new Date(formData.endDate).getTime();
				}
				if (startDate > endDate) {
			    	errorString.push(t("error.endDateBeforeStartDate") +" "+delegateItem.delegate.buyerName + "<--" + delegateItem.delegate.supplierName);
			    	noError = false;
		  		}
		  	}
			if( formData.buyers && formData.buyers.length == 0){
				errorString.push(t("error.buyerNotSelected") +" "+delegateItem.delegate.buyerName + "<--" + delegateItem.delegate.supplierName);
			   	noError = false;
		   	}
		});
		if(errorString){
			setErrorValue(errorString.join('. '));
		}
	   	//console.log("validate: "+ JSON.stringify(editFormData));
	   	return noError;
    }
    const rebuildBuyerObjects = (buyers) => {
	   let buyerObjects= [];
	   let buyer = {};
	   let valueArr = [];
       buyers.map((eachBuyer, index) => {
		   //console.log(index +" " + JSON.stringify(eachBuyer));
		   valueArr = eachBuyer.value.split("-");
		   buyer.partnershipKey = valueArr[0];
		   buyer.companyId = valueArr[1];
		   buyerObjects.push(buyer);
		   buyer = {};
		   valueArr = [];
	   });
	   return buyerObjects;
    }
    const handleCancel = () => {
		resetValues();
		fetchSupplyChainFieldValues();
	}
	const resetValues = () => {
		setDelegates([]);
		setEditFormData([]);
		errorString = [];
		setErrorValue("");
		info = "";
	}
	const searchRecords = () => {
        setDelegates([]);
        errorString = [];
		setErrorValue("");
		info = "";
        fetchSupplyChainFieldValues();
    }
    return (
        <div className="container-fluid">
            <Header />
            <div className={"container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                       <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.buyer")}
                                    </label>
                                    <Select
                                        name="buyerId"
                                        options={buyerOptions}
                                        onChange={searchBuyerHandler}
                                        placeholder={""}
                                        value={buyerSelected}
                                        isSearchable={searchBuyerLoaded}
                                        isClearable={searchBuyerLoaded}
                                        className="myselect"
                                        inputId="buyerId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t("page.supplier")}
                                    </label>
                                    <Select
                                        name="supplierId"
                                        options={supplierOptions}
                                        onChange={supplierHandler}
                                        placeholder={""}
                                        value={supplierSelected}
                                        isSearchable={supplierLoaded}
                                        isClearable={supplierLoaded}
                                        className="myselect"
                                        inputId="supplierId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 text-center">
                                <button type="submit"
                                    className="btn btn-primary btn-block search-button"
                                    onClick={searchRecords}>
                                    <span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
                                </button>
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        {delegates.length > 0 && (
						<>
						<div className="row">
                            <div className="col">
                                <span className="text-info">{info}</span>
                            </div>
                        </div>
						<div className="row">
	                    	<div className="col-md-12 text-center">
	                            <button type="submit"
	                                className="btn btn-primary btn-block search-button"
	                                onClick={submitRecords}>
	                                {t("page.submit")}
	                            </button>
	                            <button type="cancel"
	                                className="btn btn-primary btn-block search-button"
	                                onClick={handleCancel}>
	                                {t("page.cancel")}
	                            </button>
	                        </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <table className="list-table" role="table">
                                    <thead>
                                        <tr role="row">
                                            <th className="list-th" style={{ width: "2vw" }}></th>
                                            <th className="list-th" style={{ width: "30vw" }}>{t("page.supplyChain")}</th>
                                            <th className="list-th" style={{ width: "12vw" }}>{t("page.startDate")}</th>
                                            <th className="list-th" style={{ width: "12vw" }}>{t("page.endDate")}</th>
                                            <th className="list-th" style={{ width: "20vw" }}>{t("page.buyer")}</th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
                                        {delegates.map((delegateItem, index) => (
                                            <tr key={count}>
                                                <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
	                                                <input 
											          type="checkbox" 
											          value={delegateItem.delegate.partnershipKey+"-"+delegateItem.delegate.supplierKey} 
											          onChange={handleChange} 
											        />
                                                </td>
                                                <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
	                                                {delegateItem.delegate.buyerName + "<--" + delegateItem.delegate.supplierName}
                                                </td>
                                                <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
	                                                <input
														type="date"
														name="startDate"
														id="startDate"
														value={editFormData.find(item => item.partnershipKey == delegateItem.delegate.partnershipKey)?.startDate || delegateItem.delegate.startDate}
														onChange={(event) => valueHandler(delegateItem.delegate.partnershipKey, event)}
														className="form-control rounded-pill shadow-sm px-4 "
														max={today}
													/>
                                                </td>
                                                <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
	                                                <input
														type="date"
														name="endDate"
														id="endDate"
														value={setEndDateValue(delegateItem)}
														onChange={(event) => valueHandler(delegateItem.delegate.partnershipKey, event)}
														className="form-control rounded-pill shadow-sm px-4 "
													/>
                                                </td>
                                                <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
	                                                <Select
	                                                	name="buyerId"
														options={delegateItem.buyers}
														value={editFormData.find(item => item.partnershipKey == delegateItem.delegate.partnershipKey)?.buyers || []}
														onChange={(selectedOptions) => buyerHandler(selectedOptions, delegateItem.delegate.partnershipKey)}
				                                        placeholder={""}
				                                        isSearchable={buyerLoaded}
				                                        isClearable={buyerLoaded}
				                                        className="myselect"
				                                        inputId="buyerId-input"
				                                        styles={ddStyles}
				                                        isMulti={true}
													/>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
	                    	<div className="col-md-12 text-center">
	                            <button type="submit"
	                                className="btn btn-primary btn-block search-button"
	                                onClick={submitRecords}>
	                                {t("page.submit")}
	                            </button>
	                            <button type="cancel"
	                                className="btn btn-primary btn-block search-button"
	                                onClick={handleCancel}>
	                                {t("page.cancel")}
	                            </button>
	                        </div>
                        </div>
                       	</>
                        )}
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
        </div>
    );
}

export default EditSupplyChain;